export default __webpack_public_path__ + "static/media/icon.a823033f.svg";